import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/features/auth/guards'

export const Route = createFileRoute('/_authed/users')({
  beforeLoad: requireRole('ROLE_SUPER_ADMIN'),
  component: () => <h1 className="text-2xl font-semibold">Users</h1>,
})
